import './component.scss'

import 'PackWerkNurikaeSite/pages/companies/index/partials/category_label/component'

// 説明展開機能
function initializeDescriptionToggle() {
  const moreButtons = document.querySelectorAll('.js-reform-example-card__more-button')

  moreButtons.forEach(button => {
    const description = button.closest('.reform-example-card__description-container').querySelector('.js-reform-example-card__description')

    // 3行以下の場合は「もっと見る」ボタンを非表示にする
    const descriptionHeight = description.scrollHeight
    const displayHeight = description.offsetHeight

    if (descriptionHeight <= displayHeight) {
      button.classList.add('hidden')
      return
    }

    // ボタンをクリックした時はカードのリンク先に遷移する
    button.addEventListener('click', function(e) {
      e.stopPropagation()
      window.location.href = button.closest('.reform-example-card').href
    })
  })
}

window.addEventListener('load', function () {
  // 説明展開機能を初期化
  initializeDescriptionToggle()
})
